export default __webpack_public_path__ + "static/media/colorful_corridor.68c62071.jpg";